import React from 'react';
import { Card } from 'react-bootstrap';
import ShowMoreText from "react-show-more-text";
import projImg5 from "../../assets/img/n5.png";
import projectimage5 from "../../assets/img/np5.png";

const Card5 = () => {

    return (
        <Card className="CARD2" bg="dark">
              {/* <Card.Title><h2>Dynamic clustering of log anomalies</h2></Card.Title> */}

              <Card.Img variant="top" src={projectimage5} />

              <Card.Body>
                <Card.Text>
                  {" "}
                  <img className="img2" src={projImg5} />{" "}
                  <p className="text7">Pál Danyi</p>
                  <br />
                  <p className="text8">
                    Associate Professor <br /> Department of Management and
                    Business Economics, BME
                  </p>
                </Card.Text>
                <ShowMoreText lines={1}>
                  <div>
                    Commercial OCR (Optical character recognition) software has
                    a very limited success rate when it comes to historical
                    documents. Numerical information is especially difficult
                    when decimal points and thousand separators are used.
                    Context analysis does not help either, when numeric figures
                    must be precisely recognized. This is a practical project
                    where machine learning algorithms must be experimented for
                    recognizing old price lists: item and price pairs. Thousands
                    of old price list pages (from before WWII) are available in
                    digitized format for learning and testing purposes. This is
                    a unique research topic with several international
                    publication opportunities. Huge amount of sources of
                    historical economics could be analyzed this way. Also a
                    potential topic for a MSc or a PhD thesis.
                    <br />
                    <br />
                    <a href="http://arjegyzek.artortenet.hu/">Sources.</a>
                    <br />
                    <br />
                    <br />
                  </div>
                </ShowMoreText>
              </Card.Body>
            </Card>
    );
};

export default Card5;
